import React, { useEffect, useState } from "react";
import "./Properties.css";
import PropertyIcon from "../assets/Icons/property.svg";
import CheckIcon from "../assets/Icons/check.svg";
import CrossIcon from "../assets/Icons/CrossIcon.svg";

import BusinessIcon from "../assets/Icons/business.svg";
import PropertiesModal from "./Modal/PropertiesModal";
import getSettings from "../../../controllers/settings/getSettings";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";

const Properties = ({
  property,
  setProperty,
  interest,
  isError,
  isBtnDisable,
}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [isPropertyAdded, seIsPropertyAdded] = useState(true);
  const [mCurrencySettings, setMCurrencySettings] = useState({});

  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);
  useEffect(() => {
    if (property) {
      seIsPropertyAdded(true);
    } else {
      seIsPropertyAdded(false);
    }
  }, [property]);

  console.log(property);
  return (
    <>
      <PropertiesModal
        {...{
          modalStatus,
          setModalStatus,
          property,
          setProperty,
          interest,
        }}
      />
      <div
        className={`add-deal-card
        properties-card ${isBtnDisable === true && "custom-disable-card"} ${
          isPropertyAdded ? "add-deal-card-filled" : ""
        }`}
        onClick={() => {
          if (isBtnDisable === false) {
            setModalStatus(true);
          }
        }}
      >
        {isPropertyAdded ? (
          <div className="active-status">
            <img src={CheckIcon} alt="landbook" />
          </div>
        ) : (
          isError && (
            <div className="active-status">
              <img src={CrossIcon} alt="landbook" />
            </div>
          )
        )}

        <div className="card-content">
          <img
            src={PropertyIcon}
            alt="landbook"
            className="add-deal-card-icon"
          />
          <h2 className="add-deal-card-title">Property</h2>
          <div className="property-card-body">
            <div className="property-subtitle-container">
              <div>
                {!property && (
                  <p className="property-select-text">Select a Property</p>
                )}
                {property && (
                  <p className="property-label">
                    {`${property?.landArea}${" "}${property?.landAreaUnit}, ${
                      property?.propertySubType
                    }
                   ${property?.availableForSale ? "For sale" : "For rent"}
                  `}
                  </p>
                )}

                <div className="property-bottom-label-container">
                  {property && (
                    <p className="property-name">{property?.propertyTitle}</p>
                  )}

                  <p className="property-address">
                    {property ? property.address : "\n"}
                  </p>
                  <p className="property-price">
                    {property && mCurrencySettings.currency}
                    {property &&
                      `${
                        mCurrencySettings.currencyFormat === "numeral"
                          ? property?.rentalPrice > 0
                            ? FormatPriceNumeral(property?.rentalPrice ?? 0)
                            : FormatPriceNumeral(property?.sellingPrice ?? 0)
                          : property?.rentalPrice > 0
                          ? FormatPriceVerbal(property?.rentalPrice ?? 0)
                          : FormatPriceVerbal(property?.sellingPrice ?? 0)
                      }`}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Properties;
